//ver 1.1 GT

'use strict';

window.sendStats = function sendStats(category, action, label, value) {
  var params = {
    category: category,
    label: label,
  };
  if (value) {
    params.value = value;
  }
  params.asproduct = asproduct;
  params.asorderid = asorderid;
  params.asname = asname;

  WP.push(function () {
    WP.stat.show(wp_sn, params, action);
  });
};

var contextLabel = function (el) {
  if (el.closest('.header')) return 'header';
  if (el.closest('.main-footer')) return 'footer';
  return window.location.href;
};

var parseJsonAttr = function (el, name) {
  var raw = el.getAttribute(name);
  if (!raw || raw.charAt(0) !== '{') return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    console.warn('_stats.js: niepoprawny JSON w ' + name, raw);
    return null;
  }
};

// staty linkow: GA360 + dot. data-ga360-click trzyma eventCategory (przyjmowany jest
// tez starszy format z pelnym payloadem JSON), data-ga360-label nadpisuje etykiete,
// data-st-click nadaje wlasna kategorie statom dotowym. Prawy przycisk nie liczy sie.
var linkStatsHandler = function (e) {
  if (e.which === 3) return;

  var el = e.target.closest('[data-ga360-click], [data-st-click]');
  if (!el) return;

  var eventAction = deviceTouch ? 'tap' : 'click';
  var ga = parseJsonAttr(el, 'data-ga360-click');
  var eventCategory = ga ? ga.eventCategory : el.getAttribute('data-ga360-click');
  var eventLabel =
    el.getAttribute('data-ga360-label') || (ga && ga.eventLabel) || contextLabel(el);

  if (eventCategory) {
    custom360Action({
      event: 'site_interaction',
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
    });
  }

  var st = parseJsonAttr(el, 'data-st-click');
  if (st && st.category) {
    sendStats(st.category, st.action || eventAction, st.label || eventLabel, st.value);
  } else if (eventCategory) {
    sendStats(eventCategory, eventAction, eventLabel);
  }
};

document.addEventListener('click', linkStatsHandler);
document.addEventListener('auxclick', linkStatsHandler);

var scroll100Indicator = 0;
var unloadCollector = new Array(); // { id0, viewedCount0, itemCount0 }, { id1, viewedCount1, itemCount1 }  tablica do inteaktuwności sliderowych.
var forUnloadCollector = function (id, viewedCount, itemCount) {
  var objectData = new Object();
  objectData.id = id;
  objectData.viewedCount = viewedCount;
  objectData.itemCount = itemCount;
  unloadCollector.push(objectData);
  // unloadCollector push {id, viewedCount, itemCount}
};

// unload
window.indT = new Array();

window.unloadData = function () {
  var ac = ac || lastReportedSlug;

  // console.log('ac: ' + ac);

  if (!ac) return;

  var index = $('#' + ac).index();
  var count = 0;
  for (var i = 0; i < indT.length; ++i) {
    if (indT[i] == index - 1) count++;
  }
  if ((count = 4)) {
    scroll100Indicator = 1;
  } else {
    scroll100Indicator = 0;
  }
  var statElementArray = [];

  for (var pos in statElementCollector) {
    statElementArray.push(statElementCollector[pos]);
  }
  var cScrollPercentValue = cScrollPercent.burp() || 0;

  DC += cScrollPercentValue + ' ';

  try {
    custom360Action({
      event: 'unload',
      page: {
        sliderConsumption: statElementArray,
        content: { section: { scroll100Indicator: scroll100Indicator } },
        ac: ac,
        templateType: 'AS',
      },
      content: {
        pageViewCount: 1,
        scrollPercent: '',
        cScrollPercent: cScrollPercentValue,
        cS: cScrollPercentValue,
      },
    });
    //console.log(dataLayer);
  } catch (error) {
    console.error('błąd push do dataLayer: ', error);
  }
};

window.addEventListener('beforeunload', unloadData);

// debug do cScrolla
var $DEBUG = $('<div>').attr({ id: 'STAT-DEBUG' }).css({
  position: 'fixed',
  bottom: 0,
  left: 0,
  maxWidth: 500,
  maxHeight: 400,
  overflow: 'scroll',
  background: 'rgba(200,200,255,.95)',
  padding: 5,
  font: '12px Arial',
  zIndex: 9e5,
});
//.appendTo('body');

var DC = '';
setInterval(function () {
  $DEBUG.html(
    'AC: ' +
      activeSlug +
      ', lastReported: ' +
      lastReportedSlug +
      '<br>' +
      cScrollPercent.debug() +
      '<br>' +
      DC
  );
}, 250);
